import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import SelectObject from "../../ui/SelectObject";
import DataTable from "../ui/DataTable";
import { loadingCard } from "../../../helpers/loading";

interface ProgramTableProps {
  data: any;
  programList?: any[];
  showHeader?: boolean;
}

export const ProgramTable = ({ data, showHeader = false }: ProgramTableProps) => {
  const [programData, setProgramData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [programs, setPrograms] = useState<any[]>([]);
  const [selectedProgram, setSelectedProgram] = useState<number>();
  const [levelsUsed, setLevelsUsed] = useState<boolean>(false);

  const tableHeaders = [
    { label: "Program ID", key: "program_id", hide: true },
    { label: "Program", key: "program" },
    ...(levelsUsed
      ? [
          { label: "Level ID", key: "level_id", hide: true },
          { label: "Level", key: "level" },
        ]
      : []),
    { label: "Case ID", key: "id", hide: true },
    { label: "Case", key: "case_name" },
    { label: "Name", key: "name" },
  ];

  useEffect(() => {
    if (data) {
      const { programs, programData } = data;
      setProgramData(programData);
      setFilteredData(programData);
      setPrograms(programs);

      const hasLevels = programData.some((d: any) => d.level);
      setLevelsUsed(hasLevels);
    }
  }, [data]);

  const updateProgram = (e: any) => {
    setSelectedProgram(e.target.value);
    const filtered = programData?.filter((d: any) => {
      if (e.target.value === "0") {
        return d;
      } else {
        if (e.target.value.includes("-")) {
          // If the value includes a dash, it's a level
          const [programId, levelId] = e.target.value.split("-");
          return d.program_id == programId && d.level_id == levelId;
        }
        return d.program_id == e.target.value;
      }
    });

    setFilteredData(filtered);
  };

  return (
    <>
      {programData ? (
        <>
          {showHeader && (
            <Row>
              <Col>
                <h5 className="app-header-text">Current Programming</h5>
              </Col>
            </Row>
          )}
          <>
            <Row id="programs-filters">
              <Col xs={4} className="mb-1">
                <SelectObject
                  label="Program / Level (# People)"
                  initialOption="View All"
                  value={selectedProgram}
                  options={programs}
                  onUpdate={(e: any) => updateProgram(e)}
                />
              </Col>
            </Row>
            <DataTable tableHeadings={tableHeaders} tableData={filteredData} hideTitle={true} hideDownload={true} />
          </>
        </>
      ) : (
        loadingCard()
      )}
    </>
  );
};
